import React, {Component} from 'react';
import PropTypes from "prop-types";
import DataCollectorOverviewContainer from "./DataCollectorOverviewContainer";
import DataCollectorEditContainer from "./DataCollectorEditContainer";
import DataCollectorAddContainer from "./DataCollectorAddContainer";

class DataCollectorContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {
            activeView: null,
            datacollectorEdit: null,
        };

        this.translate = this.props.baseData.translate;

        this.changeView = this.changeView.bind(this);

    }

    changeView(activeView = null, datacollectorEdit = null) {

        this.setState({
            activeView,
            datacollectorEdit
        });

    }

    renderView() {

        const view = this.state.activeView;

        if (view === 'add' && this.props.baseData.checkUserRole('superadmin')) {
            return <DataCollectorAddContainer
                baseData={this.props.baseData}
                changeView={this.changeView}
            />;
        } else if (view === 'edit') {
            return <DataCollectorEditContainer
                baseData={this.props.baseData}
                datacollector={this.state.datacollectorEdit}
                changeView={this.changeView}
            />;
        } else {
            return <DataCollectorOverviewContainer
                baseData={this.props.baseData}
                currentCompany={this.props.baseData.companies.currentCompany}
                changeView={this.changeView}
            />;
        }

    }

    render() {

        const renderedView = this.renderView();

        return (
            <div>
                {renderedView}
            </div>
        );

    }

}

export default DataCollectorContainer;